module.exports = __webpack_public_path__ + "static/img/default-img.b3f8c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order-img/default-img.png
// module id = 642g
// module chunks = 17